// extracted by mini-css-extract-plugin
export default {"trigger":"Collapsible_trigger__HbLV4","content":"Collapsible_content__zdSh3","divider":"Collapsible_divider__1AvqJ","icon":"Collapsible_icon__Xpacx"};